import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { FlexCenterWrapper, ActionHeaderWrapper, Ml27p, Mr2, Mr8, Ml1, Ml8, UnderlineDecoration } from 'wrappers';
import { ClickableIcon, Text, ClickableSecondaryTextSm } from 'atoms';
import { CheckboxSvg, TrashBinSvg } from 'components/icons';
import { OutlinedButton } from 'molecules';

export const definition = {
  name: 'ActionTableHeader',
  controller: Controller,
  initialProps: ({ selectedOrdersCount, selectedSavedApplicationsListId, applications }) => ({ selectedOrdersCount, selectedSavedApplicationsListId, applications }),
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterWrapper,
      name: 'Checkbox',
      elements: [
        {
          component: wrap(wrap(ClickableIcon, Mr2), Ml27p),
          name: 'Checkbox',
          renderIf: ({ selectedSavedApplicationsListId, applications }) => selectedSavedApplicationsListId?.map((id) => id)?.some(id => applications?.map(o => o.id)?.includes(id)),
          displayValue: () => CheckboxSvg({ indeterminate: true }),
          bindings: ({ }) => ({})
        },
        {
          component: wrap(wrap(ClickableIcon, Mr2), Ml27p),
          name: 'Checkbox',
          renderIf: ({ selectedSavedApplicationsListId, applications }) => !selectedSavedApplicationsListId?.map((id) => id)?.some(id => applications?.map(o => o.id)?.includes(id)),
          displayValue: () => CheckboxSvg({ checked: false }),
          bindings: ({ }) => ({})
        },
        {
          component: wrap(Text, Ml1),
          name: 'Count',
          displayValue: ({ selectedOrdersCount }) => `${selectedOrdersCount} Selected`,
        },
        {
          component: wrap(wrap(ClickableSecondaryTextSm, UnderlineDecoration), Ml8),
          name: 'Button',
          displayValue: ({ }) => `Unselect All`,
          bindings: () => ({})
        },
      ]
    },
    {
      wrapper: FlexCenterWrapper,
      name: 'Buttons',
      elements: [
        {
          component: wrap(OutlinedButton, Mr8),
          name: 'CancelOrders',
          displayValue: () => 'Delete Selected',
          bindings: ({ }) => ({ title: 'Delete', icon: TrashBinSvg({ color: window?.settings?.secondary_color ?? '#04333b' }) }),
        },
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), ActionHeaderWrapper);